<div *ngIf="favoriteStudies.length > 0" class="favorite-studies-container">
    <div class="header">
        <h2>My Favorites</h2>
    </div>
    <div *ngIf="favoriteStudies.length > 0" class="studies-grid">
        <div class="study-card" *ngFor="let study of favoriteStudies" (click)="onStudyClick(study)">
            <div class="card-header">
                <span class="study-title">{{ study.engagementName }}</span>
                <span class="">(ID. {{ study.engagementNumber }})</span>
            </div>
            <div class="card-body">
                <div class="study-description">
                    Client: {{ study.clientName }}
                </div>
            </div>
        </div>
    </div>
</div>

<div *ngIf="favoriteStudies.length == 0" class="no-favorite-studies-container">
    <div class="header">
        <h2>My Favorites</h2>
    </div>
    <span *ngIf="favoriteStudies.length == 0">No favorite studies</span>
</div>